module.exports = __webpack_public_path__ + "assets/d9423d24dd7a1de520258e1646a6da56.mp3";